import React, { useState, useEffect } from "react";
import "./chart.css";
import ReactApexChart from "react-apexcharts";
import Energy from './Energy';
import BarChartAVkW from './BarChartAVkW';

const Charts = () => {
  const bardata1 = {
    series: [
      {
        name: "LKR",
        data: [65, 45, 75, 35, 30, 85, 25],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        foreColor: "#ffffff",
        toolbar: { show: false },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "25%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      fill: {
        opacity: 1,
      },
      grid: {
        show: false,
      },
      tooltip: {
        theme: "dark"
      },
      xaxis: {
        categories: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        axisTicks: { show: false },
        axisBorder: { show: false },
        labels: { show: true },
      },
      yaxis: {
        title: {
          text: "Energy Usage (LKR(M))",
        },
        labels: {
          formatter: (val) => `${val} LKR(M)`,
        },
        axisTicks: { show: false },
        axisBorder: { show: false },
      },
    },
  };

  const [lineData, setLineData] = useState({
    series: [
      { name: "Amps", data: [] },
      { name: "Voltage", data: [] },
    ],
    options: {
      chart: {
        height: 350,
        type: "line",
        zoom: { enabled: false },
        foreColor: "#ffffff",
        toolbar: { show: false },
        animations: {
          enabled: true,
          easing: "linear",
          dynamicAnimation: {
            speed: 2000,
          },
        },
      },
      dataLabels: { enabled: false },
      stroke: { curve: "smooth" },
      tooltip: {
        theme: "dark"
      },
      xaxis: {
        type: "datetime",
        categories: [],
        labels: { show: true },
      },
      yaxis: {
        labels: { show: true },
      },
      grid: { show: false },
    },
  });

  const addDataPoint = (voltage, current) => {
    const now = new Date().getTime();
    setLineData((prevData) => ({
      ...prevData,
      series: [
        {
          name: "Amps",
          data: [...prevData.series[0].data, { x: now, y: current }],
        },
        {
          name: "Voltage",
          data: [...prevData.series[1].data, { x: now, y: voltage }],
        },
      ],
    }));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const simulatedVoltage = Math.floor(230 + Math.random() * 10);
      const simulatedCurrent = Math.floor(30 + Math.random() * 10);
      addDataPoint(simulatedVoltage, simulatedCurrent);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <section className='charts grid2'>
        <div className='cardBox'>
          <div className="cardtopic">
            <h3>Daily Energy Consumption</h3>
          </div>
          <Energy />
        </div>

        <div className='cardBox'>
          <div className="cardtopic">
            <h3>Electricity Bill</h3>
          </div>
          <ReactApexChart options={bardata1.options} series={bardata1.series} type='bar' height={350} />
        </div>

        <div className='cardBox'>
          <div className="cardtopic">
            <h3>Voltage vs Amps</h3>
          </div>
          <ReactApexChart
            options={lineData.options}
            series={lineData.series}
            type="line"
            height={350}
          />
        </div>
      </section>

      <section className='charts grid3'>
        <div className='cardBox'>
          <div className="cardtopic">
            <h3>Energy Consumption</h3>
          </div>
          <BarChartAVkW />
        </div>
      </section>

      <br /><br /><br />
    </>
  );
};

export default Charts;
